import React, { useRef } from "react";

type AudioPlayerProps = {
  audioAnswer: string;
  textAnswer: string;
};

const AudioPlayer: React.FC<AudioPlayerProps> = ({ audioAnswer, textAnswer }) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);


  return (
    <div>
      {/* 音频控件 */}
      <audio
        ref={audioRef}
        className="media-wrap audio-wrap"
        id="img-6270c574-a348-4578-9096-8ea444e991a9"
        title="chu.m4a"
        src={audioAnswer}
        controls
      />
      {/* <p>{textAnswer}</p> */}
    </div>
  );
};

export default AudioPlayer;